/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './ConcentrationSection.module.scss';

import { ConcentrationGraph } from './ConcentrationGraph';

export const ConcentrationSection = () => {
  const { t } = useInt();

  return (
    <Section layout="centered" background="#f5f6f8">
      <div className={styles.grid}>
        <div className={styles.text}>
          <TitleBlock
            align="left"
            title={t('Three “independent” suppliers, one ultimate owner')}
            description={t(
              "Diversifying across vendors means little if they roll up to the same parent. Corporate linkage connects your suppliers by ownership so a single failure — or a single sanctioned owner — doesn't take out three lines at once.",
            )}
          />
        </div>

        <ConcentrationGraph />
      </div>
    </Section>
  );
};
